import { useMemo } from "react";
import { ORDERS_NS } from "@/i18n/ns";

const textSearchKeys = ["name", "phone", "email", "note"];
const ns = `${ORDERS_NS}:search`;
export const useTextSearchOptions = ({ t }) => {
  return useMemo(() => {
    return textSearchKeys.map((key) => ({
      label: t(`${ns}.text.type_opts.${key}`),
      value: key,
    }));
  }, [t]);
};
export const useHasTextSearch = (query) =>
  Boolean(query.search || query.search_by);
